module.exports = __webpack_public_path__ + "static/img/storageImg1.1c2652a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storageImg1.png
// module id = O8Cs
// module chunks = 2